import {ReactComponent as CorgiFood} from './icons/corgi-with-blu-poo-pills-in-dish-new.svg';
import {ReactComponent as CorgiToilet} from './icons/corgi-on-toilet-new.svg';
import {Button} from '@mui/material';
import PopUp from './pooTypePop.js'
import React from 'react';
import $ from 'jquery';

function TimerCount({running}) {
  const [time, setTime] = React.useState(0);

  React.useEffect(() => {
    $.ajax({
      type: "POST",
      url: "/wp-admin/admin-ajax.php",
      data: {
        action: 'poo_load',
        message_id: $('.poo_load').val()
      },
      cache: false,
      success: function(resp) {
        if(resp['data'][0].length){
          if(running === true){
            setTime(new Date().getTime() - resp['data'][0][0]['start_time'])
          }else{
            setTime(0)
          }
        }
      }
    })},
    [running]
  )

  React.useEffect(() => {
    let interval = 0
    if(running === true){
      interval = setInterval(() => {
        setTime(prevTime => prevTime + 100);
      }, 100);
    }else{
      clearInterval(interval);
      setTime(0);
    }
    return () => clearInterval(interval);
  }, [running]);

  return(
    <div>
      <span>{("0" + Math.floor((time / 3600000) % 60)).slice(-2)}</span>
      <span>:{("0" + Math.floor((time / 60000) % 60)).slice(-2)}</span>
      <span className="timer-little">:{("0" + Math.floor((time / 1000) % 60)).slice(-2)}</span>
    </div>
  );
}

class Timer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      running: false,
      pop: false,
      timeStart: null,
      exist: false
    };
    this.toggle = this.toggle.bind(this);
  }

  toggle = () => {
    let curTime = new Date().getTime();
    if(this.state.running === true) {
      this.setState({
        pop: !this.state.pop,
        exist: true
      })
    } else if(this.state.running === false) {
      $.ajax({
        type: "POST",
        url: "/wp-admin/admin-ajax.php",
        data: {
          action: 'poo_start',
          startTime: curTime,
          message_id: $('.poo_start').val()
        },
        cache: false,
        success: function(html) {
        }
      });
    }
    this.setState({
      running: !this.state.running
    });
  }

  togglePop = () => {
    this.setState({
      pop: !this.state.pop,
      running: false,
      exist: true
    });
  };

  render() {
    $.ajax({
      type: "POST",
      url: "/wp-admin/admin-ajax.php",
      data: {
        action: 'poo_load',
        message_id: $('.poo_load').val()
      },
      cache: false,
      success: function(resp) {
        if(resp['data'][0].length && this.state.running === false && this.state.exist === false){
          this.setState({running: true})
        }
      }.bind(this)
    });
    return (
      <div>
        {this.state.pop ? <PopUp toggle={this.togglePop} /> : null}
        <div className={"timer-container"}>
          <div className="blu-poo-columns">
            <div className="blu-poo-instructions">
              <h1>Blu Poo Tracker</h1>
              <h3>Directions</h3>
              <p><span>Step 1:</span> Take 2 capsules with a meal and start the timer.</p>
              <p><span>Step 2:</span> Monitor your bathroom visits for approx 9-30 hours.</p>
              <p><span>Step 3:</span> When your poop turns blue, stop the timer.</p>
              <p><span>Step 4:</span> Follow the instructions to record poop type.</p>
            </div>
            <div className="blu-poo-timer">
              {this.state.running ? <CorgiToilet className="corgi-pooping" width="10%"/> : <CorgiFood className="corgi-food" width="10%"/>}
              <TimerCount running={this.state.running}/>
              {this.state.running ? <Button className="poo-stop" variant="contained" onClick={this.toggle}>Stop</Button> : <Button className="poo-start" variant="outlined" onClick={this.toggle}>Start</Button>}
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default Timer;
